import React, {useEffect} from "react"
import {useSelector} from "react-redux";
import {Controller, useFormContext} from "react-hook-form";
import classNames from "classnames";
import RenderedHtmlContent from "../../../../../../shared/virtual_congress/components/rendered_html_content";
import CustomError from "../custom_error";
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import ConditionalDivWrapper from "./conditional_div_wrapper";
import MomentUtils from '@date-io/moment';
import {convertFieldNameToClassName} from "../../../utils";

const BootstrapDatepicker = ({
                               name,
                               label,
                               options,
                               required,
                               variant,
                               readOnly,
                               defaultValue,
                               placeholder,
                               hint,
                               fieldValue,
                               errorMessage
                             }) => {
  const {register, setValue, setError, clearErrors} = useFormContext();

  const labelWidth = useSelector(state => state.label_width) || "3"
  const inputWidth = useSelector(state => state.input_width) || "8"
  const isHorizontal = variant !== "vertical"

  useEffect(() => {
      console.log(".date_" + name.split(".")[1])
    $(".date_" + name.split(".")[1]).each(function (index, elem) {
      var locale = $(elem).data("locale")
      var custom_picker_attributes = $(elem).data("datepicker_attributes")
      if (locale == null || locale == "" || locale == undefined) {
        locale = "en"
      }
      console.log("custom_picker_attributes", custom_picker_attributes)

      if (custom_picker_attributes == null || custom_picker_attributes == "" || custom_picker_attributes == undefined) {
        custom_picker_attributes = {}
      } else {
        console.log("Got custom_picker_attributes", custom_picker_attributes)
      }

      $.datepicker.regional[locale];

      if(name.includes("birthday")){
          custom_picker_attributes["yearRange"] = "1900:2023";
      } else {
          custom_picker_attributes["yearRange"] = "1900:2100";
      }


      let attrs = {
        inline: false,
        firstDay: 1,
        changeMonth: true,
        changeYear: true,
        dateFormat: 'dd.mm.yy',
        onSelect: (e) => {
            console.log(e)
            clearErrors(name)
            setValue(name, e);
        }
      }
      attrs = $.extend({}, attrs, custom_picker_attributes)
      $(this).datepicker(attrs);
    })

    return () => {
      $(".datepicker").datepicker("destroy");
    }
  }, [])

  return <div className={classNames("form-group datepicker-container", `datepicker-${convertFieldNameToClassName(name)}-container`, {"row": isHorizontal})}>
    <label htmlFor={name}
           className={classNames(`r-label`, {[`col-md-${labelWidth} col-form-label-sm`]: isHorizontal})}>
      <RenderedHtmlContent html={label}/>
    </label>
    <ConditionalDivWrapper wrapWithDiv={isHorizontal} className={`col-md-${inputWidth}`}>
      <input
        {...register(name)}
        disabled={readOnly}
        id={name}
        className={classNames("form-control form-control-sm w-100 datepicker", {"is-invalid": errorMessage}, "date_" + name.split(".")[1])}
        autoComplete="off"
        data-datepicker_attributes={fieldValue}
        placeholder={placeholder}
        defaultValue={defaultValue}
      />
      {hint && <small className="form-text text-muted">
        <RenderedHtmlContent html={hint}/>
      </small>}
      <CustomError error={errorMessage}/>
    </ConditionalDivWrapper>
  </div>
}

const MaterialUiDatepicker = ({
                                name,
                                label,
                                options,
                                required,
                                variant,
                                readOnly,
                                defaultValue,
                                placeholder,
                                hint,
                                errorMessage
                              }) => {
  const {control} = useFormContext();
  const format = "DD.MM.YYYY"

  return <div className={`form-group datepicker-container datepicker-${convertFieldNameToClassName(name)}-container`}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Controller
        name={name}
        control={control}
        render={({field: { onChange, value }}) => <KeyboardDatePicker
          onChange={(event) => {
            onChange(event.format(format))
          }}
          value={value}
          id={name}
          label={label}
          format={format}
          variant={variant}
          error={!!errorMessage}
          margin="dense"
          fullWidth
          helperText={errorMessage || <RenderedHtmlContent html={hint}/>}
          InputProps={{
            readOnly: readOnly,
          }}
        />}
      />
    </MuiPickersUtilsProvider>
  </div>
}

const FlaveDatepicker = (props) => {
  const formFieldStyle = useSelector(state => state.form_field_style)

  switch (formFieldStyle) {
    case "material_ui":
      return <MaterialUiDatepicker {...props} variant={"standard"}/>
    case "material_ui_outlined":
      return <MaterialUiDatepicker {...props} variant={"outlined"}/>
    case "material_ui_filled":
      return <MaterialUiDatepicker {...props} variant={"filled"}/>
    case "boostrap_vertical":
      return <BootstrapDatepicker {...props} variant={"vertical"}/>
    case "boostrap_horizontal":
    default:
      return <BootstrapDatepicker {...props} variant={"horizontal"}/>
  }
}

export default FlaveDatepicker
